import Vue from 'vue'


import VueRouter from 'vue-router';
Vue.use(VueRouter);
//Vue.config.productionTip = false;

import Page1 from './Page1'
import Page2 from './Page2'
import Page3 from './Page3'

const routes = [
  { path: '/page1', component: Page1 },
  { path: '/page2', component: Page2 },
  { path: '/page3', component: Page3 },
];

const router = new VueRouter({
  mode: 'history',
  routes // short for `routes: routes`
})

/* eslint-disable no-new */
new Vue({
  router,
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js